export enum SkyTokensMessageType {
  FocusLastToken = 0,
  FocusActiveToken = 1,
  FocusPreviousToken = 2,
  FocusNextToken = 3,
  RemoveActiveToken = 4
}
